module.exports = __webpack_public_path__ + "img/bybitlogo.233cf4ff.png";